import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import normalizeProjectStoreNavList from '@Hub/Header/utils/normalizeProjectStoreNavList';

import { ProjectContext } from '@core/context';
import useClassy from '@core/hooks/useClassy';
import { useProjectStore } from '@core/store';

import Button from '@ui/Button';
import Dropdown from '@ui/Dropdown';
import Icon from '@ui/Icon';
import Menu from '@ui/Menu';

import classes from '../../style.module.scss';
import { useFeatureFilter } from '../../utils/hooks';
import { NavLinkWrapper } from '../NavLinks';

const LinkMenu = () => {
  const { project } = useContext(ProjectContext);
  const { pathname } = useLocation();
  const isLP = ['/', ''].includes(pathname);
  const bem = useClassy(classes, 'Header');

  const [topNavRight] = useProjectStore(s => [normalizeProjectStoreNavList(s.data.appearance.navigation.right)]);

  const makeTopNavItems = (item, i) => {
    // Don't include user controls in menu since we show it on nav bar
    if (item.type === 'user') return null;
    return (
      <NavLinkWrapper key={`tagtype-${item.type}-${i}`} classOverride={bem('Menu-Item', 'Menu-Item_link')} item={item}>
        {item.text || item.type}
      </NavLinkWrapper>
    );
  };

  // the GLP for single project enterprises should use the nav items in the parent
  const topRightItems = isLP && project.flags.singleProjectEnterprise ? project.parent.topnav.right : topNavRight;

  const linkMenuItems = useFeatureFilter(topRightItems).map(makeTopNavItems);

  // Don't show menu if there are no valid link items
  if (linkMenuItems.every(item => item === null)) return null;

  return (
    <Dropdown>
      <Button
        aria-label="Open links menu"
        className={bem('-link', 'NavItem', 'NavItem_md', 'rm-Header-top-link')}
        ghost
      >
        <Icon aria-hidden="true" name="more-vertical" size="md" />
      </Button>
      <Menu>{linkMenuItems}</Menu>
    </Dropdown>
  );
};

export default LinkMenu;
